export const compareLicencePlates = (licencePlate1: string, licencePlate2: string) => {
  return (
    licencePlate1.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() ===
    licencePlate2.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
  );
};
